<template>
  <form @submit.prevent="handleSubmit">
    <div class="row">
      <div class="col-md-6">
        <label for="experience" class="form-control-label w-100">
          Ruta<span class="required">*</span>
        </label>
        <el-select
            v-model="formModel.trail"
            size="large"
            class="w-100"
        >
          <el-option
              v-for="selectItem in trails"
              :key="selectItem.id"
              :value="selectItem.id"
              :label="selectItem.name"
          />
        </el-select>
        <label for="type" class="form-control-label w-100">
          Usuario<span class="required">*</span>
        </label>
        <el-select
            v-model="formModel.user"
            size="large"
            class="w-100"
        >
          <el-option
              v-for="selectItem in users"
              :key="selectItem.id"
              :value="selectItem.id"
              :label="selectItem.firstname"
          />
        </el-select>
      </div>
      <div class="col-md-6">
        <div class="col-12">
          <label for="latitude" class="form-control-label">
            Fecha<span class="required">*</span>
          </label>
          <br>
          <el-date-picker
              v-model="formModel.day"
              type="date"
              value-format="YYYY-MM-DD"
              placeholder="Seleccione un dia"
              :shortcuts="shortcuts"
              :class="v.day.$errors.length >0 ? 'is-invalid' : ''"
          />
          <p v-if="v.day.$error" class="invalid-feedback mb-0">
            <small>
              {{ v.day.$errors[0].$message }}
            </small>
          </p>
        </div>

        <label for="places" class="form-control-label mt-2">
          Nro de asistentes<span class="required">*</span>
        </label>
        <input
            style="max-width: 100px;"
            id="places"
            v-model="formModel.places"
            :class="[
                        'form-control',
                        v.places.$error ? 'is-invalid' : '',
                      ]"
            type="number"
            placeholder=""
        />
        <p v-if="v.places.$error" class="invalid-feedback invalid-field mb-0">
          <small>
            {{ v.places.$errors[0].$message }}
          </small>
        </p>
      </div>
    </div>
    <div class="mt-3">
      <button
        type="submit"
        class="float-end btn btn-primary text-white bg-blue-600 rounded-lg border border-primary hover:bg-blue-900">
        {{ buttonText }}
      </button>
      <button
        class="me-2 float-end btn btn-primary text-danger bg-white border border-danger rounded-lg hover:bg-blue-900"
        @click="handleCancel"
      >
        Cancelar
      </button>
    </div>
  </form>
</template>

<script setup>
import {ref, defineProps, computed, onMounted} from "vue";
import {useStore} from "vuex";
import {useRouter} from "vue-router";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Swal from 'sweetalert2';
const store = useStore();
const router = useRouter();

const props = defineProps({
   entity: {
     type: Object,
     required: false
   },
  action: {
     type: String,
    required: true
  }
})
const formModel = ref(props.entity|| {});

const trails = computed(() => store.state.trail.trails);
const users = computed(() => store.state.user.users);
const buttonText = computed(() => props.action === 'create' ? 'Crear' : 'Guardar cambios');

const getTrails = async () => {
  return await store.dispatch("trail/getTrails");
};
const getUsers = async () => {
  return await store.dispatch("user/getUsers");
};
const shortcuts = [
  {
    text: 'Hoy',
    value: new Date(),
  }
]
onMounted(() => {
  getTrails();
  getUsers();
  if(props.entity.trail){
    formModel.value.trail = props.entity.trail.id
  }
  if(props.entity.user){
    formModel.value.user = props.entity.user.id
  }
});

const rules = computed(() => {
  return {
    trail: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    user: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    places: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    },
    day: {
      required: helpers.withMessage("Este campo es obligatorio", required),
    }
  };
});

const v$ = useVuelidate(rules, formModel);
const v = v$.value;

const handleSubmit = () => {
  v$.value.$validate();
  if (!v$.value.$invalid) {
    if(props.action === 'create'){
      createEntity(formModel.value);
    }else{
      updateEntity(formModel.value);
    }
  }
};

const handleCancel = () => {
  router.push({ name: "Reservas", params: {} });
};

const updateEntity = async (data) => {
    await store.dispatch("reserve/edit", data).then(async (res) => {
      if (res.status && (res.status === 200 || res.status === 201)) {
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Reserva editada satisfactoriamente.',
          showConfirmButton: false,
          timer: 3000
        })
        await router.push({name: "Reservas", params: {}});
      } else {
        await Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Se ha producido un error.',
          showConfirmButton: false,
          timer: 3000
        })
      }
    })
};

const createEntity = async (data) => {
  data.trail = '/api/trails/'+data.trail
  data.user = '/api/users/'+data.user
  await store.dispatch("reserve/add", data).then(async (res) => {
    if (res.status === 200 || res.status === 201) {
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Reserva creada satisfactoriamente.',
        showConfirmButton: false,
        timer: 3000
      })
      router.push({name: "Reservas", params: {}});
    } else {
      await Swal.fire({
        position: 'top-end',
        icon: 'error',
        title: res.response.data['hydra:description'],
        showConfirmButton: false,
        timer: 3000
      })
    }

  })
}
</script>
